import { MdTableChart } from "react-icons/md";

const getDataFieldsTable = () => {
  return [
    {
      title: "Rows",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Values",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 25,
      valueType: "Number",
      canEdit: false,
    },
  ];
};

const getCustomizationFieldsTable = () => {
  return [
    {
      title: "Row Total",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isRowTotalVisible",
    },
    {
      title: "Column Total",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isColumnTotalVisible",
    },
    {
      title: "Custom Alignmant",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isCustomAlign",
      innerComponents: [
        {
          title: "Row Align",
          type: "textAlign",
          reduxKey: "rowAlign",
          defaultValue: "left",
        },
        {
          title: "Value Align",
          type: "textAlign",
          reduxKey: "valueAlign",
          defaultValue: "center",
        },
      ],
    },
    {
      title: "Table Head",
      type: "CONTAINER_WITHOUT_TOGGLE",
      innerComponents: [
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: true,
          reduxKey: "isTableHeadBold",
          isParent: true,
        },
        {
          title: "Head Font Color",
          type: "fontColor",
          defaultValue: "#374151",
          reduxKey: "tableHeadFontColor",
        },
        {
          title: "Head Background Color",
          type: "fontColor",
          defaultValue: "#e5e7eb",
          reduxKey: "tableHeadBgColor",
        },
      ],
    },

    {
      title: "Conditional Formatting",
      type: "CONDITIONAL_FORMATTING",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "conditionalFormatting",
      itemInArray: true,
      defaultValue: [],
    },
  ];
};
const getTableChartDetails = () => {
  return {
    chartType: "recharts",
    imageSrc: "/graph_img/Table.png",
    label: "Table",
    value: "table",
    icon: <MdTableChart className="text-xl text-blue-950" />,
    fileName: "Table.js",
  };
};
export {
  getDataFieldsTable,
  getCustomizationFieldsTable,
  getTableChartDetails,
};
